<template id="swal-template">
  <div id="swalHTML" style="display:none;">
    <div>
      <h4 class="text-center pb-2">{{ $t('lbl_EMPBE_AliyunVerify_SLIDER_LABEL') }}</h4>
      <div id="__nc" style="margin-left:auto;margin-right:auto;width:100%;">
        <div id="nc_clone"></div>
      </div>
      <hr />
      <a :href="'https://www.chinaplasonline.com/CPS24/idx/' + currentLang" target="_blank" class="w-100">
        <img class="w-100" :src="'https://cdn.adsalecdn.com/CPS24/Files/Image/General/chinaplas_web_banner_' + langid + '.jpg?x-oss-process=image/format,webp/quality,lossless'">
      </a>
    </div>
  </div>
</template>

  
<script>

import { aliyunVerifyService } from "../../src/_services"

export default {
  // 验证成功后，服务端报错（如账号/密码等错误），需要重置滑块
  props: {
    reload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ic: '', // noCaptcha实例
    };
  },
  watch: {
    reload: {
      handler(newV) {
        console.log(newV);
        if (newV) {
          this.nc.reset();  // 重置滑块
        }
      },
    },
  },
  mounted() {
    // 初始化方法
  },
  computed:{
    langid() {
      return localStorage.getItem("currentLangId")
    },
    currentLang(){
      return localStorage.getItem("currentLang")
    }
  },
  methods: {
    init() {
      var nc_token = ["FFFF0N00000000007174", (new Date()).getTime(), Math.random()].join(':');
      var nc = NoCaptcha.init({
        renderTo: '#nc',
        appkey: 'FFFF0N00000000007174',
        scene: 'nc_message_h5',
        token: nc_token,
        trans: { "key1": "code200" },
        elementID: ["usernameID"],
        is_Opt: 0,
        language: "cn",
        timeout: 10000,
        retryTimes: 5,
        errorTimes: 5,
        inline: false,
        apimap: {
          // 'analyze': '//a.com/nocaptcha/analyze.jsonp',
          // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
        },
        bannerHidden: false,
        initHidden: false,
        callback: async function (data) {
            var VerifyResult = await aliyunVerifyService.ValidateAliyunVerify(data.csessionid, data.sig, nc_token)
            if (VerifyResult) {
              self.$emit('slideCallback', data);
            }

        },
        error: function (s) {
        }
      });
      NoCaptcha.setEnabled(true);
      nc.reset();//请务必确保这里调用一次reset()方法

      NoCaptcha.upLang('cn', {
        'LOADING': this.$t("lbl_EMPBE_AliyunVerify_Loading"),//加载
        'SLIDER_LABEL': this.$t("lbl_EMPBE_AliyunVerify_SLIDER_LABEL"),//等待滑动
        'CHECK_Y': this.$t("lbl_EMPBE_AliyunVerify_CHECK_Y"),//通过
        'ERROR_TITLE': this.$t("lbl_EMPBE_AliyunVerify_ERROR_TITLE"),//拦截
        'CHECK_N': this.$t("lbl_EMPBE_AliyunVerify_CHECK_N"), //准备唤醒二次验证
        'OVERLAY_INFORM': this.$t("lbl_EMPBE_AliyunVerify_OVERLAY_INFORM"),//二次验证
        'TIPS_TITLE': this.$t("lbl_EMPBE_AliyunVerify_TIPS_TITLE")//验证码输错时的提示
      });

      const self = this;
      var myLang = {
        'cn': {
          //加载状态提示。
          'LOADING': this.$t('lbl_EMPBE_AliyunVerify_Loading'),
          //等待滑动状态提示。
          'SLIDE': this.$t('lbl_EMPBE_AliyunVerify_SLIDER_LABEL'),
          //验证通过状态提示。
          'SUCCESS': this.$t('lbl_EMPBE_AliyunVerify_CHECK_Y'),
          //验证失败触发拦截状态提示。
          'ERROR': this.$t('lbl_EMPBE_AliyunVerify_ERROR_TITLE'),
          //验证失败触发拦截状态提示。
          'FAIL': this.$t('lbl_EMPBE_AliyunVerify_CHECK_N')
        }
      }
    },
    popup() {
      let el = document.getElementById('swalHTML');
      var elInnerHtml = el.innerHTML.replace("nc_clone", "nc");
      this.$swal({
        html: elInnerHtml,
        showConfirmButton: false
      })
      this.init();
    }
  },
};
</script>
  
<style lang="css">
#nc {
  width: 100%;
  display: contents;
}

.nc_wrapper {
  width: 100% !important;
  height: 43px !important;
  line-height: 43px !important;
}

.nc_n1t,
.nc_bg,
.nc_iconfont,
.scale_text,
.nc-lang-cnt,
.nc_scale {
  height: 43px !important;
  line-height: 43px !important;
}
</style>
  